import moment from 'moment';

/**
 * @function FormatDates
 * @description Handles Various Date Formats Given Specific Key
 * @param {Object} date - Date Object
 * @param {string} key - Matching Format Type
 * @return {string} Formatted Date Value
 * @example formatDates('2015-01-12T15:21:29', 'MONTH') => 'January 12, 2015'
 * @example https://devhints.io/moment
 */
const formatDates = (date, key) => {

  switch (key) {
    case 'MM-DD-YYYY':
      return moment(date).format('MM-DD-YYYY');
      // returns format => 06-09-2014
    case 'M-D-YYYY':
      return moment(date).format('M-D-YYYY');
      // returns format => 6-9-2014
    case 'MM/DD':
      return moment(date).format('MM/DD');
      // returns format => 06/09
    case 'MM/DD/YYYY':
      return moment(date).format('MM/DD/YYYY');
      // returns format => 06/09/2014
    case 'M/DD/YY':
      return moment(date).format('M/DD/YY');
      // returns format => 6/09/2014
    case 'SHORT_MONTH':
      return moment(date).format('ll');
      // returns format => Nov 9, 2014
    case 'MONTH':
      return moment(date).format('LL');
      // returns format => November 9, 2014
    case 'SHORT_DATE_TIME':
      return moment(date).format('lll');
      // returns Nov 9 2014 9:32pm
    case 'DATE_TIME':
      return moment(date).format('LLL');
      // returns November 9, 2014 9:32pm
    case 'SHORT_DAY_DATE_TIME':
      return moment(date).format('llll');
      // returns Mon, Nov 9, 2014 9:32pm
    case 'DAY_DATE_TIME':
      return moment(date).format('LLLL');
      // returns Monday, November 9, 2014 9:32pm
    case 'DATE_AT_TIME':
      return `${moment(date).format('MM-DD-YYYY')} @ ${moment(date).format('hh:mm a')}`;
    default:
      return moment(date).format('MM-DD-YYYY');
      // returns format => 06-09-2014
  }
};

export default formatDates;
